// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReducedPlanYearDto
 */
export interface IReducedPlanYearDto {
    /**
     * 
     * @type {number}
     * @memberof IReducedPlanYearDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReducedPlanYearDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReducedPlanYearDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReducedPlanYearDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the IReducedPlanYearDto interface.
 */
export function instanceOfIReducedPlanYearDto(value: object): value is IReducedPlanYearDto {
    return true;
}

export function IReducedPlanYearDtoFromJSON(json: any): IReducedPlanYearDto {
    return IReducedPlanYearDtoFromJSONTyped(json, false);
}

export function IReducedPlanYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReducedPlanYearDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IReducedPlanYearDtoToJSON(json: any): IReducedPlanYearDto {
    return IReducedPlanYearDtoToJSONTyped(json, false);
}

export function IReducedPlanYearDtoToJSONTyped(value?: IReducedPlanYearDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

